<template>
  <div
    class="con"
    :style="{
      marginTop: mt,
    }"
  >
    <div class="cards-container text-center">
      <swiper
        :slidesPerView="1"
        :spaceBetween="10"
        :centeredSlides="false"
        :autoplay="false"
        :pagination="false"
        :navigation="true"
        :modules="modules"
        :breakpoints="{
          300: {
            slidesPerView: 1,
            spaceBetween: 10,
          },
          568: {
            slidesPerView: 2,
            spaceBetween: 10,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 10,
          },
          992: {
            slidesPerView: 3,
            spaceBetween: 10,
          },
        }"
        class="mySwiper cards d-flex justify-content-between align-items-center gap-3"
      >
        <swiper-slide v-for="item in data" :key="item?.id">
          <div class="card w-100">
            <div class="header">
              <img
                class="card-img w-100 h-100"
                :src="item?.img"
                :alt="item?.title"
              />
              <router-link class="subscribe-btn" :to="'/courses/' + item?.id">
                الدخول للكورس
              </router-link>
            </div>
            <div class="footer">
              <img
                class="channel-profile-img"
                :src="item?.channelProfileImg"
                :alt="item?.title"
              />
              <p>
                {{ item?.description }}
              </p>
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from "swiper/vue";

// Import Swiper styles
import "swiper/css";

import "swiper/css/pagination";
import "swiper/css/navigation";

// import required modules
import { Autoplay, Pagination, Navigation } from "swiper/modules";

export default {
  name: "NewCoursesYoutubeCardsComponent",
  components: {
    Swiper,
    SwiperSlide,
  },
  props: {
    data: {
      type: Array,
      required: true,
    },
    mt: {
      type: String,
      default: "0",
    },
  },
  setup() {
    return {
      modules: [Autoplay, Pagination, Navigation],
    };
  },
};
</script>

<style scoped>
.con {
  padding: 0 1rem;
}
.con h2 {
  color: #dad2c5;
  font-size: 2.25rem;
  font-weight: 500;
  margin: 0;
  padding: 0;
}
.swiper {
  height: 100%;
}
.swiper-slide {
  min-width: calc(100% / 3.5);
  max-width: calc(100% / 3.5);
  text-align: center;
  font-size: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.cards-container .cards {
  margin: 0 auto;
  overflow: hidden;
}
.cards-container .cards .card {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 1rem;
  overflow: hidden;
  width: 100%;
  min-height: 350px;
  max-height: 350px;
  padding: 0;
  background: transparent;
  border: 0;
}
.cards-container .cards .card .header {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 1rem;
  overflow: hidden;
}
.cards-container .cards .card .header .card-img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 1rem;
}
.cards-container .cards .card .header .subscribe-btn {
  position: absolute;
  bottom: -20%;
  background-color: #2b4239;
  color: #fff;
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  font-size: 1rem;
  font-weight: 700;
  text-decoration: none;
  width: calc(100% - 2rem);
  min-height: 40px;
  transition: all 0.3s ease-in-out;
}
.cards-container .cards .card .header .subscribe-btn:hover {
  background-color: #dad2c5;
  color: #0d0d0d;
  transition: all 0.3s ease-in-out;
}
.cards-container .cards .card:hover .header .subscribe-btn {
  bottom: 2rem;
  transition: bottom 0.3s;
}
.cards-container .cards .card .footer {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 0.5rem;
  text-align: start;
}
.cards-container .cards .card .footer .channel-profile-img {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  object-fit: cover;
}
.cards-container .cards .card .footer h2 {
  color: #1e1e1e;
  font-size: 1.25rem;
  font-weight: 700;
  margin: 0;
  padding: 0;
}
.cards-container .cards .card .footer p {
  color: #1e1e1e;
  font-size: 1rem;
  font-weight: 500;
  margin: 0;
  padding: 0;
}
body.dark .cards-container .cards .card .footer h2,
body.dark .cards-container .cards .card .footer p {
  color: #dad2c5;
}
@media (max-width: 992px) {
  .con {
    margin-top: 0;
  }
  .swiper-slide {
    width: calc(100% / 3) !important;
    min-width: calc(100% / 3) !important;
    max-width: calc(100% / 3) !important;
  }
}
@media (max-width: 768px) {
  .swiper-slide {
    width: 50% !important;
    min-width: 50% !important;
    max-width: 50% !important;
  }
  .cards-container .cards .card .footer .channel-profile-img {
    width: 40px;
    height: 40px;
  }
}
@media (max-width: 568px) {
  .swiper-slide {
    width: 100% !important;
    min-width: 100% !important;
    max-width: 100% !important;
  }
}
</style>
